export default __webpack_public_path__ + "static/media/simkt.db020675.ico";